// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__30PpT","amount":"Amount_amount__1VeuH","tip":"Amount_tip__2d2s9","tipHeader":"Amount_tipHeader__1WgmE","tipsWrap":"Amount_tipsWrap__2L7h3"};